import { render, staticRenderFns } from "./ProceedModal.vue?vue&type=template&id=6bd37bdc&scoped=true"
import script from "./ProceedModal.vue?vue&type=script&lang=js"
export * from "./ProceedModal.vue?vue&type=script&lang=js"
import style0 from "./ProceedModal.vue?vue&type=style&index=0&id=6bd37bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd37bdc",
  null
  
)

export default component.exports